/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import PropTypes from "prop-types";
import Select, { components }  from "react-select";
import {FormattedMessage} from "react-intl";

const messages = {
  noOptions: {
    id: "default.noOptions",
    defaultMessage: "No options",
  },
  select: {
    id: "default.selectPaymentMethods",
    defaultMessage: "Select payment methods",
  },
};

const NoOptionsMessage = (props) => {
  return (
    <components.NoOptionsMessage {...props}>
      <FormattedMessage {...messages.noOptions} />
    </components.NoOptionsMessage>
  );
};

const Placeholder = (props) => {
  return (
    <components.Placeholder {...props}>
      <FormattedMessage {...messages.select} />
    </components.Placeholder>
  );
};

class InputGroup extends React.Component {
  handleChange = selectedOption => {
    this.props.onChange({
      value: selectedOption,
      field: this.props.field.fieldName,
    });
  };

  render() {
    const { options, className, closeMenuOnSelect, defaultValue } = this.props.field;
    const defaultValues = defaultValue ? options.filter((it) => defaultValue.includes(it.value)) : [];
    return (
      <fieldset className={className}>
        <Select
          components={{ NoOptionsMessage, Placeholder }}
          isMulti={true}
          closeMenuOnSelect={closeMenuOnSelect}
          onChange={this.handleChange}
          defaultValue={defaultValues}
          options={options} />
      </fieldset>
    );
  }
}

InputGroup.propTypes = {
  field: PropTypes.object,
  formErrors: PropTypes.object,
  formValues: PropTypes.object,
  hasErrors: PropTypes.bool,
  onChange: PropTypes.func,
};

export default InputGroup;
